import { type LayoutManifest } from "./manifest";

/**
 * Slot manifest for the standard layout. Empty for v1 — the standard layout
 * still uses the legacy hardcoded TopBar / SummaryBar / CatalogPanel and
 * doesn't read slot mappings yet. The Designer's slot_mapping JSON has no
 * effect for standard-layout deployments today.
 *
 * Migrating standard to <Slot> populates this manifest. Until then the editor
 * shows an empty list + a hint that this layout doesn't support overrides.
 */
export const STANDARD_LAYOUT_MANIFEST: LayoutManifest = {
  id: "standard",
  slots: [],
};
